import Vue from 'vue';
import { getActivityList, getMissionsList, getJoinMemberList,  getMemberPointsList, getMemberPointsStatus } from '../../../services/personnelService/pointsCardService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [], //群發消息的人員名單
  activityList:[],
  missionsList:[],
  memberPointsList: [],
  memberPointsStatus:[],
  pagination: {
    current_page: 0,
    per_page: 15
  },
};

// getters
const getters = {};

// actions
const actions = {
  //取得集點卡活動列表
  async getActivityHandler({ commit }) {
    const data = await getActivityList();
    commit('setActivityList', data);
  },
  //取得集點任務列表
  async getMissionsHandler({ commit }, input) {
    const data = await getMissionsList(input);
    commit('setMissionsList', data);
  },
  async getMemberListHandler({ commit }, info) {
    const data = await getJoinMemberList(info);
    commit('setMemberList', data);
    return data;
  },
  //取得會員集點卡活動列表
  async getMemberPointsHandler({ commit }, input) {
    const data = await getMemberPointsList(input);
    commit('setMemberPointsList', data);
  },
  //取得會員集點卡任務狀態
  async getMemberPointsStatusHandler({ commit }, input) {
    const data = await getMemberPointsStatus(input);
    commit('setMemberPointsStatus', data);
  },
  

};

// mutations
const mutations = {
 
  setActivityList(state, data) {
    Vue.set(state, 'activityList', data.data.list);
  },
  setMissionsList(state, data) {
    Vue.set(state, 'missionsList', data.data.missions);
  },
  setMemberList(state, data) {
    Vue.set(state, 'memberList', data.data.members);
  },
  setMemberPointsList(state, data) {
    Vue.set(state, 'memberPointsList', data.data.list);
  },
  setMemberPointsStatus(state, data) {
    Vue.set(state, 'memberPointsStatus', data.data.missions);
  },

  //重置分頁
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 15
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
